/**
 * Square KPI tiles in a user-chosen number of columns.
 * Class names are complete Tailwind strings so the JIT compiler keeps them.
 * Clicking a tile opens that KPI's history at the viewer's location.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { KpiTileCard } from './KpiTileCard';
import { kpiGridClass, type KpiTile } from './types';

interface KpiTileGridProps {
  tiles: KpiTile[];
  columns: number;
  t: (key: string) => string;
  keyPrefix?: string;
  className?: string;
  onHide?: (kpiId: string) => void;
}

export const KpiTileGrid: React.FC<KpiTileGridProps> = ({
  tiles,
  columns,
  t,
  keyPrefix,
  className,
  onHide
}) => (
  <div className={`grid gap-1 items-start ${kpiGridClass(columns)}${className ? ` ${className}` : ''}`}>
    {tiles.map((tile) => (
      <Link
        key={keyPrefix ? `${keyPrefix}-${tile.kpiId}` : tile.kpiId}
        to={`/performance/kpis/${tile.kpiId}`}
        className="block rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-primary-text)]"
        aria-label={`${tile.kpiName} — ${t('kpi.historyOpen') || 'View history'}`}
      >
        <KpiTileCard
          tile={tile}
          t={t}
          onHide={onHide ? () => onHide(tile.kpiId) : undefined}
        />
      </Link>
    ))}
  </div>
);
